'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-countdown-to-future-date/~/react/react.js
// module id = 452
// module chunks = 168707334958949